module.exports = __webpack_public_path__ + "images/hero_mission4_6351a9ed45a60dd562002c1e93e8c45f.png";